module.exports = __webpack_public_path__ + "static/media/loginGuide1_Jap.1d9206ee.png";